import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { indigo } from '@mui/material/colors';
import Layout from '../layout';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {Link} from "react-router-dom";

export default function HomeContainer() {

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
      console.log("Height updated:", window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const boxStyle1 = {
    px: 4,
    py: 8,
    minHeight: { xs: 'auto', md: `${windowHeight - 64}px` },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: 'radial-gradient(circle at center, #fff 70%, #ddd 100%)',
    boxShadow: '0px 0px 10px 0px #9fa8da',
    borderBottom: '1px solid #9fa8da',
  };

  const boxStyle2 = {
    px: 4,
    py: {xs: 8},
    backgroundColor: '#e8eaf6',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 0px 10px 0px #9fa8da',
    borderBottom: '1px solid #9fa8da',
    
  };

  const boxStyle3 = {
    px: 4,
    py: { xs: 8},
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 0px 10px 0px #9fa8da',
    borderBottom: '1px solid #9fa8da',  };

  const items = [
    "Todas as etapas do lançamento em ordem cronológica",
    "Mapa mental do seu método",
    "Acesso individualizado para cada membro do seu time",
    "Gestão dos seus contratos de parceria",
    "Gestor de links com redirect para tudo o que você precisa",
  ];


  const items2 = [
    "Infoprodutores",
    "Lançadores",
    "Experts",
    "Estrategistas digitais",
    "Copywriters",
    "Social Medias",
    "E toda a equipe envolvida no lançamento"
  ];


  return (
    <Layout>
      <Box sx={boxStyle1}>
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid item>
            <Typography
              variant="h2"
              align="center" 
              color={indigo[700]}
              fontWeight={500}
            >
              Launcherfy
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="h6"
              align="center"
              color={indigo[700]}
              fontWeight={500}
            >
              {/* A plataforma de lançamentos
              indispensável para <b>Lançadores</b> e <b>Experts.</b> */}
              A principal plataforma de lançamentos digitais. Transforme seu conteúdo em negócio.
            </Typography>
          </Grid>
          <Grid item container sx={{alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}> 
            <Grid item xs={12} md={6}> 
              {/* <Typography variant='h5' align="left"> 
                A plataforma de lançamentos
                indispensável para <b>Lançadores</b> e <b>Experts</b>
              </Typography> */}
              <Typography variant="h6" color="text.secondary" sx={{ textAlign: {xs: 'center', sm: 'left'} }}> 
                Tenha total controle sobre o seu lançamento e
                nunca mais se esqueça de nenhum ponto ou ação estratégica
                que precisa executar. Launcherfy reúne em um só lugar,
                tudo o que você precisa para saber exatamente qual o próximo
                passo a dar rumo ao sucesso do seu lançamento.
              </Typography>
              <List>
                {items.map((itemText, index) => (
                  <ListItem key={index}>
                    <ListItemIcon>
                      <CheckCircleIcon color="success" />
                    </ListItemIcon>
                    <ListItemText >{itemText}</ListItemText>
                  </ListItem>
                ))}
                <ListItem key="key_mais">
                  {/* <ListItemIcon>
                    <CheckCircleIcon color="success" />
                  </ListItemIcon> */}
                  <ListItemText >E muito mais...</ListItemText>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} sm={6} sx={{p:2}}> 
              <CardMedia
                component="img"
                image="/mockup.png"
                alt="green iguana"
              />
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}> 
              <Button component={Link} to="/profile" variant='contained' sx={{ backgroundColor: '#25D366', '&:hover': { backgroundColor: "#139445" } }}>Cadastrar e testar gratuitamente </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      
      <Box sx={boxStyle2}>
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center' }}>
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              color={indigo[700]}
              fontWeight={500}
            >
              DESENVOLVA E GERENCIE TODO O SEU LANÇAMENTO EM UM SÓ LUGAR
            </Typography>
            <Typography variant='h6' align="center">
              Chega de se perder no processo ou de esquecer de algum detalhe importante.
            </Typography>
          </Grid>
          <Grid item container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} md={6} sx={{ textAlign: 'center', gap: 2, display: 'flex', flexDirection: 'column', p:2 }}>
              <Typography variant="h6" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Veja tudo o que precisa fazer no seu lançamento
                em ordem cronólogica por prioridades.

              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <CardMedia sx={{borderRadius: 2}}
                component="img"
                image="/plat.png"
                alt="plataforma"
              />
            </Grid>
            <Grid item xs={12} sx={{p:2}}>
              <Button component={Link} to="/profile" variant='contained' sx={{ backgroundColor: indigo[500], '&:hover': { backgroundColor: indigo[700] } }}>Quero meu lançamento organizado</Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box sx={boxStyle3}>
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              color={indigo[700]}
              fontWeight={500}
            >
              PLATAFORMA 100% CUSTOMIZADA
            </Typography>
            <Typography variant='h6' align="center">
              Insira suas informações personalizadas conforme a estratégia do seu lançamento
            </Typography>
            <CardMedia sx={{ borderRadius: 2 }}
              component="img"
              image="/101.png"
              alt="plataforma"
            />
          </Grid>
        </Grid>
      </Box>
      <Box sx={boxStyle2}>
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              color={indigo[700]}
              fontWeight={500}
            >
              PLANEJE O SEU MÉTODO E SUA
              DISTRIBUIÇÃO DE CONTEÚDO 
            </Typography>
          </Grid>
          <Grid item container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} md={6} sx={{ textAlign: 'center', gap: 2, display: 'flex', flexDirection: 'column', p: 2 }}>
              <Typography variant="h6" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Crie um mapa mental para identificar as etapas
                que não podem faltar no produto que
                será vendido no seu lançamento ou planeje a
                sua distribuição de conteúdo


              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <CardMedia sx={{ borderRadius: 2 }}
                component="img"
                image="/method2.png"
                alt="method"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box sx={boxStyle3}>
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              color={indigo[700]}
              fontWeight={500}
            >
              GERE CONTRATOS AUTOMATICAMENTE
              COM SEUS PARCEIROS E EQUIPE
            </Typography>
          </Grid>
          <Grid item container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} md={6} sx={{ textAlign: 'center', gap: 2, display: 'flex', flexDirection: 'column', p: 2 }}>
              <Typography variant="h6" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Crie seus contratos de forma rápida,
                fácil e com validade legal, apenas
                preenchendo os dados de cada parte
                e os combinados entre elas.
                Os termos jurídicos são gerados
                automaticamente para você
                neste modelo de contrato.
                E, depois de preencher, você ainda poderá
                assinar digitalmente
                pelo site do governo gov.br,
                com apenas 1 clique.
              </Typography>

              <Button component={Link} to="/profile" variant='contained' sx={{ backgroundColor: indigo[500], '&:hover': { backgroundColor: indigo[700] } }}>Quero meu lançamento organizado</Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <CardMedia sx={{ borderRadius: 2, border: `solid 1px ${indigo[200]}` }}
                component="img"
                image="/contract.png"
                alt="method"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box sx={boxStyle2}>
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              color={indigo[700]}
              fontWeight={500}
            >
              PARA QUEM É A LAUNCHERFY?
            </Typography>
          </Grid>
          <Grid item container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} md={6} sx={{ textAlign: 'center', gap: 2, display: 'flex', flexDirection: 'column', p: 2, mt: 4 }}>
              <Typography variant="h6" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                A Launcherfy é a solução ideal para todos
                que desejam lançar infoprodutos com
                organização e domínio dos processos
                do início ao fim.
              </Typography>
              {items2.map((itemText, index) => (
                <ListItem key={index} sx={{p:0}}>
                  <ListItemIcon>
                    <CheckCircleIcon color="success" />
                  </ListItemIcon>
                  <ListItemText >{itemText}</ListItemText>
                </ListItem>
              ))}
            </Grid>
            <Grid item xs={12} md={6}>
              <CardMedia sx={{ borderRadius: 2, border: `solid 1px ${indigo[200]}` }}
                component="img"
                image="/organization.png"
                alt="method"
              />
            </Grid>
            <Grid item sx={{p:2, display: 'flex', flexDirection: 'column' }}>
              <Button component={Link} to="/profile" variant='contained' sx={{ backgroundColor: indigo[500], '&:hover': { backgroundColor: indigo[700] } }}>Receber demonstração</Button>
            </Grid>

          </Grid>
        </Grid>
      </Box>
      <Box sx={boxStyle3}>
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100vw', p:2 }}>
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              color={indigo[700]}
              fontWeight={500}
            >
              TENHA O MELHOR APOIO PARA
              DESENVOLVER SEU LANÇAMENTO
            </Typography>
          </Grid>
          <Grid item container sx={{ alignItems: 'center' }}>
            <Grid item xs={12} md={6} sx={{ textAlign: 'center', gap: 2, display: 'flex', flexDirection: 'column', p: 2, mt: 4 }}>
              <Typography variant="h6" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Receba suporte de segunda a sexta, das 8h às 18h.
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                Encontre as respostas às principais dúvidas
                diretamente no FAQ.
              </Typography>

            </Grid>
            <Grid item xs={12} md={6} sx={{textAlign: '-webkit-center'}}>
              <CardMedia sx={{ borderRadius: 2, border: `solid 1px ${indigo[200]}`, maxWidth: '250px' }}
                component="img"
                image="https://www.zert.se/wp-content/uploads/2019/08/Support.png"
                alt="method"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
